module.exports = __webpack_public_path__ + "img/cz-partners-zive.ba907c71.png";